import React from "react";
import * as Scrivito from "scrivito";
import { UncontrolledTooltip } from "reactstrap";
import { ProjectTree } from "components/ProjectTree/ProjectTree";
import { ToggleShowPictures } from "components/ProjectTree/ToggleShowPictures";
import { useTranslate } from "hooks";
import { useProject } from "stores/project";

export const ProjectStructure = Scrivito.connect(() => {
  const translate = useTranslate();
  const project = useProject();
  const projectTitle = project?.title || "";
  const tooltipId = `tooltip-${projectTitle.replace(/[^a-zA-Z0-9]/g, "_")}`;

  if (!project) {
    return (
      <div className="d-flex flex-column h-100 w-100 justify-content-start align-items-center">
        {translate("NO_PROJECT_SELECTED")}
      </div>
    );
  }

  return (
    <div className="mb-3 d-flex flex-column flex-grow-1 overflow-hidden">
      <div className="mb-3 flex-shrink-0">
        <h5 className="text-uppercase text-truncate">
          {translate("ADD_PRODUCT_MODAL_PROJECT_STRUCTURE_TITLE")} |{" "}
          <span id={tooltipId}>{projectTitle}</span>
        </h5>
        <UncontrolledTooltip target={tooltipId} placement="top-start">
          {projectTitle}
        </UncontrolledTooltip>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <span className="text-gray-500">
            {translate("ADD_PRODUCT_MODAL_PROJECT_STRUCTURE_SUBTITLE")}
          </span>
          <ToggleShowPictures />
        </div>
      </div>
      <div className="w-100 border rounded-1 p-3 d-flex flex-grow-1 overflow-hidden">
        <ProjectTree
          options={{
            dndDisabled: true,
            copyNodeDisabled: true,
            deleteNodeDisabled: true,
            duplicateNodeDisabled: true,
            editNodeDisabled: true,
            overscanCount: 10,
            ModelViewDisabled: true,
            downloadModalDisabled: true,
            resetOnPaste: false,
            productAddingModal: true,
          }}
        />
      </div>
    </div>
  );
});
